import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const SupportNewMessageIcon = forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <Icon ref={ref} viewBox="0 0 16 17" fill="currentColor" {...props}>
      <path
        fillRule="evenodd"
        d="M1.92 2.42a2 2 0 0 1 1.41-.59H7.8a.67.67 0 0 1 0 1.34H3.33a.67.67 0 0 0-.66.66v9.06l1.53-1.53c.12-.12.29-.2.47-.2h8a.67.67 0 0 0 .66-.66V8.7a.67.67 0 0 1 1.34 0v1.8a2 2 0 0 1-2 2H4.94l-2.47 2.47a.67.67 0 0 1-1.14-.47V3.83a2 2 0 0 1 .59-1.41Z"
        clipRule="evenodd"
      />
      <path d="M12 6.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z" />
      <path
        fillRule="evenodd"
        d="M12 3.17a1.33 1.33 0 1 0 0 2.66 1.33 1.33 0 0 0 0-2.66ZM9.33 4.5a2.67 2.67 0 1 1 5.34 0 2.67 2.67 0 0 1-5.34 0Z"
        clipRule="evenodd"
      />
    </Icon>
  )
);
export default SupportNewMessageIcon;
